<template>
  <div class="smartphone">
    <div class="smartphone-content">
      <div class="barra-notificacion text-right">
        <i class="fas fa-wifi"></i>
        <i class="fas fa-signal"></i>
        <span>&nbsp;{{ clock }}</span>
      </div>
      <h3 class="top-menu">
        <i class="fas fa-bars menu-icon"></i>
        Cruvi
        <span class="text-right">
          <i class="fas fa-search"></i>
        </span>
      </h3>
      <div class="row no-gutters text-center" id="smart_main_menu">
        <div class="col active">
          Productos
        </div>
        <div class="col">
          Carrito
        </div>
        <div class="col">
          Pedidos
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clock: "08:43 PM"
    };
  },
  created() {
    this.updateClock();
    this.startInterval();
  },
  methods: {
    startInterval() {
      setInterval(() => {
        this.updateClock();
      }, 20000);
    },
    updateClock() {
      let d = new Date();
      let h = d.getHours();
      let twoDig = dig => {
        return dig < 9 ? "0" + dig : dig;
      };
      let med = h > 11 ? " PM" : " AM";
      h = twoDig(h % 12);
      let m = twoDig(d.getMinutes());
      this.clock = h + ":" + m + med;
    }
  }
};
</script>

<style lang="scss" scope>
/* The device with borders */
.smartphone {
  position: relative;
  width: 360px;
  height: 640px;
  /* margin: auto; */
  border: 16px black solid;
  border-top-width: 60px;
  border-bottom-width: 60px;
  border-radius: 36px;
}

/* The horizontal line on the top of the device */
.smartphone:before {
  content: "";
  display: block;
  width: 60px;
  height: 5px;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #333;
  border-radius: 10px;
}

/* The circle on the bottom of the device */
.smartphone:after {
  content: "";
  display: block;
  width: 35px;
  height: 35px;
  position: absolute;
  left: 50%;
  bottom: -65px;
  transform: translate(-50%, -50%);
  background: #333;
  border-radius: 50%;
}

.smartphone:hover:after {
  background: #666;
}

/* The screen (or content) of the device */
.smartphone .smartphone-content {
  width: 328px;
  height: 520px;
  background: #fff;
}

.smartphone .barra-notificacion {
  font-size: 0.8rem;
  background: #111;
  color: #fff;
}
.smartphone .smartphone-content .top-menu {
  background: #990000;
  color: white;
  font-size: 1.2rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  .text-right {
    float: right;
  }
}
#smart_main_menu .col {
  padding: 0.5rem 0;
  background: #08abd4;
  color: #fff;
  border-bottom: 2px solid #04a5ce;
}
#smart_main_menu .col.active {
  padding: 0.5rem 0;
  background: #02bed4;
  border-bottom: 2px solid #ffa500;
}
</style>
